import clsx from 'clsx';

import styles from './ThreeDots.module.scss';

interface ThreeDotsProps {
  /** Extra class forwarded to the wrapping `<div>`. */
  className?: string;
}

/**
 * Tiny inline "typing"-style loading indicator: three dots that pulse
 * in sequence. Use as a lightweight in-flight cue (e.g. while a chat
 * message is being generated). For larger loading states use `Spinner`
 * or `SkeletonLoader`.
 */
export const ThreeDots = ({ className }: ThreeDotsProps) => {
  return (
    <div data-testid="three-dots" className={clsx(styles.root, className)}>
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
};
